import { createReducer, on } from "@ngrx/store";
import { Leftover, LeftoverBrief } from "../../../shared/models/leftover.model";
import * as LeftoverActions from './leftover.actions';
import { IngredientLocation } from "../../../shared/enums/ingredient-location.enum";

// --- Filter Map Interface ---
export interface LeftoverFilterMap {
  default_location: IngredientLocation[];
  is_popular: boolean | null;
}

// --- State ---
export interface LeftoverState {
  leftovers: Leftover[];
  loading: boolean;
  loaded: boolean;
  error: any;
  filters: LeftoverFilterMap;
  searchTerm: string;
  briefResults: LeftoverBrief[];
  briefLoading: boolean;
}

const initialState: LeftoverState = {
  leftovers: [],
  loading: false,
  loaded: false,
  error: null,
  filters: {
    default_location: [],
    is_popular: null
  },
  searchTerm: '',
  briefResults: [],
  briefLoading: false,
};

export const leftoverReducer = createReducer(
  initialState,
  on(LeftoverActions.loadLeftovers, (state) => ({ ...state, loading: true })),
  on(LeftoverActions.loadLeftoversSuccess, (state, { leftovers }) => ({
    ...state,
    leftovers,
    loaded: true,
    loading: false
  })),
  on(LeftoverActions.loadLeftoversFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(LeftoverActions.addLeftoverSuccess, (state, { leftover }) => ({
    ...state,
    leftovers: [...state.leftovers, leftover]
  })),
  on(LeftoverActions.updateLeftoverSuccess, (state, { leftover }) => ({
    ...state,
    leftovers: state.leftovers.map(l => l.leftover_id === leftover.leftover_id ? leftover : l)
  })),
  on(LeftoverActions.deleteLeftoverSuccess, (state, { leftoverId }) => ({
    ...state,
    leftovers: state.leftovers.filter(l => l.leftover_id !== leftoverId)
  })),
  on(LeftoverActions.setLeftoverFilters, (state, { filters }) => ({
    ...state,
    filters
  })),
  on(LeftoverActions.clearLeftoverFilters, (state) => ({
    ...state,
    filters: {
      default_location: [],
      is_popular: null
    }
  })),
  on(LeftoverActions.updateLeftoverSearchTerm, (state, { term }) => ({
    ...state,
    searchTerm: term
  })),
  on(LeftoverActions.resetLeftoverFilters, (state) => ({
    ...state,
    filters: {
      default_location: [],
      is_popular: null
    }
  })),
  on(LeftoverActions.resetLeftoverSearchTerm, (state) => ({
    ...state,
    searchTerm: ''
  })),
  on(LeftoverActions.updateLeftoverSearchTerm, (state, { term }) => ({
    ...state,
    searchTerm: term,
    briefResults: term.trim().length < 3 ? [] : state.briefResults
    })),
    on(LeftoverActions.searchLeftoversBrief, (state) => ({
      ...state,
      briefLoading: true
    })),
    on(LeftoverActions.searchLeftoversBriefSuccess, (state, { results }) => ({
      ...state,
      briefLoading: false,
      briefResults: results
    })),
    on(LeftoverActions.searchLeftoversBriefFailure, (state) => ({
      ...state,
      briefLoading: false
    })),
    on(LeftoverActions.resetLeftoversBrief, (state) => ({
      ...state,
      briefResults: []
    })),
  on(LeftoverActions.resetLeftovers, () => initialState)
);
